<template>
  <v-app>
    <v-container fluid :class="$style.appContainer">
      <slot />
    </v-container>
  </v-app>
</template>

<script setup></script>

<style lang="scss" module>
.appContainer {
  background-color: white;
  height: 100%;
  padding: 0 !important;
  position: relative;
}
</style>
